import {
  mapScaleLine,
  updateMapMousePosition,
} from "../components/map/mapUtils";

const initialState = {
  map: null,
  mapGetPoints: [],
  mapSetPoints: [],
  measurements: [],
  baseLayers: [],
  settings: null,
  google: {
    geocoding: [],
    reverse: [],
  },
  activeBaseLayer: 0,
  bookmarks: [],
  quickSearchOptions: [...window["appConfig"]()["quickSearch"]],
};

export default function mapReducer(state = initialState, action) {
  switch (action.type) {
    case "map/init":
      return { map: { ...action.payload } };
      break;

    case "map/quicksearch/update":
      {
        let newState = { ...state };

        newState.quickSearchOptions[action.payload.serviceIndex]["layers"][
          action.payload.layerIndex
        ]["checked"] = action.payload.checked;

        return newState;
      }
      break;

    case "map/setbaselayer":
      {
        let newState = { ...state };

        newState.activeBaseLayer = action.payload;

        return newState;
      }
      break;

    case "map/measurements/add":
      {
        let newState = { ...state };

        newState.measurements = [...newState.measurements, action.payload];

        return newState;
      }

      break;

    case "map/measurements/delete":
      {
        let newState = { ...state };

        newState.measurements.splice(action.payload, 1);

        return newState;
      }

      break;

    case "map/measurements/clearall":
      {
        let newState = { ...state };

        newState.measurements = [];

        return newState;
      }

      break;

    case "map/mapGetPoints/add":
      {
        let newState = { ...state };

        newState.mapGetPoints.unshift(action.payload);

        return newState;
      }

      break;

    case "map/mapGetPoints/delete":
      {
        let newState = { ...state };

        newState.mapGetPoints.splice(action.payload, 1);

        return newState;
      }

      break;

    case "map/google/geocoding/add":
      {
        let newState = { ...state };

        newState.google.geocoding.unshift(action.payload);

        return newState;
      }

      break;

    case "map/google/geocoding/delete":
      {
        let newState = { ...state };

        newState.google.geocoding.splice(action.payload, 1);

        return newState;
      }

      break;

    case "map/bookmarks/add":
      {
        let newState = { ...state };

        newState.bookmarks.unshift(action.payload);

        return newState;
      }

      break;

    case "map/bookmarks/delete":
      {
        let newState = { ...state };

        newState.bookmarks.splice(action.payload, 1);

        return newState;
      }

      break;

    case "map/mapSetPoints/add":
      {
        let newState = { ...state };

        newState.mapSetPoints.unshift(action.payload);

        return newState;
      }

      break;

    case "map/mapSetPoints/delete":
      {
        let newState = { ...state };

        newState.mapSetPoints.splice(action.payload, 1);

        return newState;
      }

      break;

    case "map/settings/scale/update":
      {
        let newState = { ...state };

        newState.settings.scale[action.payload.property] = action.payload.value;

        mapScaleLine(newState.settings.scale);

        return newState;
      }

      break;

    case "map/settings/projection/update":
      {
        let newState = { ...state };

        newState.settings.projection = action.payload;

        updateMapMousePosition(newState.settings.projection);

        return newState;
      }

      break;

    default:
      {
        let newState = { ...state };

        if (!newState.settings) {
          newState.settings = { ...window["appConfig"]()["settings"] };
        }

        return newState;
      }
      break;
  }
}
